import { EmsBatteryMode, EmsSgReadyMode } from 'src/Libs/dynamic-power-prices/types'
import { AI360ChartData } from '../types'

interface LineChartStoreState {
  time: AI360ChartData['time']
  powerPrice: AI360ChartData['powerPrice']
  feedInPrice: AI360ChartData['feedInPrice']
  solarProduction: AI360ChartData['solarProduction']
  solarForecast: AI360ChartData['solarForecast']
  emsBatteryMode: EmsBatteryMode
  emsSgReadyMode: EmsSgReadyMode
  defaultDataIndex: number | null
  isLegendEnabled: {
    powerPrice: boolean
    solarData: boolean
    feedInPrice: boolean
  }
}

type Listener = () => void

let storeState: LineChartStoreState = {
  time: null,
  powerPrice: null,
  feedInPrice: null,
  solarProduction: null,
  solarForecast: null,
  emsBatteryMode: EmsBatteryMode.NormalOperation,
  emsSgReadyMode: EmsSgReadyMode.Normal,
  defaultDataIndex: null,
  isLegendEnabled: {
    powerPrice: true,
    solarData: true,
    feedInPrice: true,
  },
}

const listeners = new Set<Listener>()

/**
 * Line chart store for managing the state of the line chart tooltip and legend.
 */
export const LineChartStore = {
  get: (): LineChartStoreState => storeState,

  set: (next: Partial<LineChartStoreState>): void => {
    storeState = { ...storeState, ...next }
    listeners.forEach(l => l())
  },

  subscribe: (listener: Listener): (() => void) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
}
